import { render } from "./wechataccount.vue?vue&type=template&id=0dd6532a&scoped=true"
import script from "./wechataccount.vue?vue&type=script&lang=js"
export * from "./wechataccount.vue?vue&type=script&lang=js"

import "./wechataccount.vue?vue&type=style&index=0&id=0dd6532a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd6532a"]])

export default __exports__